<template>
  <v-app>
    <!-- <sbpps v-if="domain_id == 'LOCAL'" />  -->
    <sbpps v-if="domain_id == 'BETA'" />
    <sbpps v-else-if="domain_id == 'SBPPS'" />
    <vvp v-else-if="domain_id == 'VVP'" />
    <zeal v-else-if="domain_id == 'ZEAL'" />
    <sgs v-else-if="domain_id == 'SGS'" />
    <wws v-else-if="domain_id == 'WWS'" />
    <local v-else-if="domain_id == 'LOCAL'" />
    <local v-else/>
   
  </v-app>
</template>

<script>
// import Sbpps from "./Login/Sbpps.vue";
// import Vvp from "./Login/Vvp.vue";
// import Zeal from "./Login/Zeal.vue";
// import Wws from "./Login/Wws.vue";
// import Local from "./Login/Local.vue";
export default {
  components: {
    "sbpps": () => import('./Login/Sbpps.vue'),
    "vvp": () => import('./Login/Vvp.vue'),
    "zeal": () => import('./Login/Zeal.vue'),
    "sgs": () => import('./Login/SGS.vue'),
    "wws": () => import('./Login/Wws.vue'),
    'local': () => import('./Login/Local.vue')
  },
  data() {
    return {
     domain_id:"localhost",
    };
  },
  methods: {
 
  },
  created() {
    this.trust_logo = localStorage.getItem("EPS-trust-logo");
  },
  mounted() {
    var url = window.location.href;
    this.hide_parent_sign_up = false;
    if (url.includes("sbpps")) {
      this.domain_id = "SBPPS"
      document.title="SBPPS"
    } else if (url.includes("localhost")) {
      this.domain_id = "LOCAL"
      document.title="Local"
    } else if (url.includes("wisdomworldschool")) {
      this.domain_id = "WWS"
      document.title="Wisdom World School ERP"
    } else if (url.includes("vvp.edupluscampus")) {
     this.domain_id = "VVP"
     document.title="Vishwakarma Vidyalay School ERP | Pune"
    } else if (url.includes("universalwisdomschool")) {
      this.domain_id = "WWS"
      document.title="UWS School ERP | Universal Wisdom School | Balewadi"
    }else if (url.includes("zealerp")) {
     this.domain_id = "ZEAL"
     document.title="Zeal School ERP | Pune"
    }
    else if (url.includes("sgs")) {
     this.domain_id = "SGS"
     document.title="SGS"
    }
    else if (url.includes("ui-beta")) {
     this.domain_id = "BETA"
     document.title="Beta"
    } else {
      this.domain_id = "LOCAL"
      document.title="Local"
    }
    this.message = localStorage.getItem("login-page-msg");
    if (this.message) {
      this.showSnackbar("#C62828", this.message);
    }
    console.log("login-page-msg>>" + localStorage.getItem("login-page-msg"));

    this.$store.commit("setquick_links", false);
    this.$store.commit("setcalendar_flag", false);
    this.$store.commit("settoday_events", false);

    localStorage.clear();
    if (this.$session.exists()) {
      this.$session.destroy();
    }
  },
};
</script>
